import routerOptions0 from "/data/www/nextrecruitment.nl/next-recruitment/nuxt/node_modules/.pnpm/nuxt@3.11.2_@opentelemetry+api@1.8.0_@unocss+reset@0.60.2_eslint@8.57.0_floating-vue@5.2.2_ro_l2yz53darwyp4cuwk2v6553dia/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...routerOptions0,
}